import { faTimes } from '@fortawesome/free-solid-svg-icons';
import propTypes from 'prop-types';
import { useContext } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { CLOSE, HOW_TO_REDEEM } from '../../config/text/text';
import ThemeContext from '../../providers/ThemeProvider';
import { useRedeemInstructions } from '../../services/vouchers';
import Icon from '../Icon';
import { GetVoucherButton } from './GetVoucherButton';
import VoucherInstructions from './VoucherInstructions';
import { DEFAULT_EVENT_KEY, REDEEM_EVENT_KEY } from './constants';

const VoucherAccordionRedeem = ({ voucher, setToggle, toggleState }) => {
  const theme = useContext(ThemeContext);
  const instructions = useRedeemInstructions({
    active: toggleState === REDEEM_EVENT_KEY,
    toggleState,
    voucher,
  });

  return (
    <>
      <Accordion.Collapse eventKey={REDEEM_EVENT_KEY}>
        <div className="redeem-wrapper">
          <div className="redeem-header">
            <button
              aria-label={CLOSE}
              className="redeem-close"
              onClick={() => setToggle(DEFAULT_EVENT_KEY)}
              type="button"
            >
              <Icon faIcon={faTimes} />
            </button>
          </div>
          <div className="redeem-body">
            <VoucherInstructions
              instructions={instructions}
              title={HOW_TO_REDEEM}
            />
          </div>
          <GetVoucherButton className="full-width" voucher={voucher} />
        </div>
      </Accordion.Collapse>
      <style jsx>{`
        .redeem-wrapper {
          border-top: 1px solid #eee;
          border-bottom: 1px solid #eee;
          padding-bottom: 10px;
          margin-bottom: 14px;
        }
        .redeem-header {
          display: flex;
          flex-direction: row-reverse;
          padding: 10px;
        }
        .redeem-body {
          padding: 20px 10px 10px 20px;
          background: ${theme.colors.white};
          border: 1px solid ${theme.colors.lightboxgrayborders};
          border-radius: 5px;
          max-height: 360px;
          overflow: auto;
          margin-bottom: 14px;
        }
        .redeem-close {
          background-color: transparent;
          border: none;
        }
      `}</style>
    </>
  );
};

VoucherAccordionRedeem.propTypes = {
  setToggle: propTypes.func.isRequired,
  toggleState: propTypes.string.isRequired,
  voucher: propTypes.object,
};

export default VoucherAccordionRedeem;
